module.exports = __webpack_public_path__ + "img/jiejuefangan_pic.b604fde1.png";